import React from 'react'
import PropTypes from 'prop-types'
import AccountCircle from '@mui/icons-material/AccountCircle'

const AccountCircleIcon = ({ height, width, ...more }) => {
	
	return (
		<AccountCircle
			height={height}
			width={width}
			{...more}
		/>
	)
}

AccountCircleIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default AccountCircleIcon
